import type * as React from "react";

import { cx } from "../../lib/cx";
import { Icon, type IconName } from "./Icon";
import s from "./ContactLink.module.css";

export interface ContactLinkProps extends React.ComponentPropsWithoutRef<"a"> {
  href: string;
}

/** El icono sale del esquema del `href`; no hay que decirle qué es. */
function iconoDe(href: string): IconName {
  if (href.startsWith("tel:")) return "phone";
  if (href.startsWith("mailto:")) return "mail";
  if (/wa\.me|whatsapp/.test(href)) return "message-square";
  return "external-link";
}

/**
 * Un teléfono, un mail o un WhatsApp para tocar: el dato con su icono. Los
 * externos (`http`) se abren en otra pestaña. Reemplaza a los `<a href="tel:">`
 * desnudos del panel.
 */
export function ContactLink({ href, className, children, target, rel, ...rest }: ContactLinkProps) {
  const externo = /^https?:/.test(href);
  const destino = target ?? (externo ? "_blank" : undefined);
  return (
    <a
      href={href}
      target={destino}
      rel={rel ?? (destino === "_blank" ? "noopener noreferrer" : undefined)}
      className={cx(s.link, className)}
      {...rest}
    >
      <Icon name={iconoDe(href)} size={16} />
      <span className={s.texto}>{children ?? href.replace(/^(tel|mailto):/, "")}</span>
    </a>
  );
}
